module.exports = __webpack_public_path__ + "img/film-preestirat-packetgrup.abc7431d.jpg";